import { shallowRef } from "vue";
import { useModalController as useBootstrapModalController } from "bootstrap-vue-next";
import { useNewUiEnabled } from "@/components/newUi/core/useNewUiEnabled";

export interface ConfirmProps {
  title?: string;
  body?: string;
  okTitle?: string;
  cancelTitle?: string;
  okVariant?: string;
  okOnly?: boolean;
}

export interface PendingConfirm {
  props: ConfirmProps;
  resolve: (confirmed: boolean | null) => void;
}

export const pendingConfirm = shallowRef<PendingConfirm | null>(null);

const confirmInUi = (props: ConfirmProps): Promise<boolean | null> =>
  new Promise((resolve) => {
    pendingConfirm.value?.resolve(null);

    pendingConfirm.value = { props, resolve };
  });

// Same API as the controller of bootstrap-vue-next, but `confirm` opens the new UI dialog when the flag is on.
export const useModalController = () => {
  const controller = useBootstrapModalController();
  const newUiEnabled = useNewUiEnabled();

  const confirm = (options: Parameters<NonNullable<typeof controller.confirm>>[0]) =>
    newUiEnabled.value
      ? confirmInUi((options as { props?: ConfirmProps }).props ?? {})
      : controller.confirm!(options);

  return { ...controller, confirm };
};
